export enum ExperiencePropertyType {
    DetachedHouse = 0,
    Townhouse = 1,
    TwoToFourUnitStructure = 2,
    CondoUnit = 3,
    FivePlusMultifamily = 4,
    ResidentialMixedUse = 5,
    Commercial = 6,
}

export enum ExperiencePropertyTypeCategory {
    CoreOptions = 0,
    Other = 1,
}

export const ExperiencePropertyTypeOptions = [
    {
        id: ExperiencePropertyType.DetachedHouse,
        name: 'House (detached)',
        category: ExperiencePropertyTypeCategory.CoreOptions,
    },
    {
        id: ExperiencePropertyType.Townhouse,
        name: 'Townhouse (attached)',
        category: ExperiencePropertyTypeCategory.CoreOptions,
    },
    {
        id: ExperiencePropertyType.TwoToFourUnitStructure,
        name: '2-4 Unit Structure',
        category: ExperiencePropertyTypeCategory.CoreOptions,
    },
    {
        id: ExperiencePropertyType.CondoUnit,
        name: 'Condo. Unit',
        category: ExperiencePropertyTypeCategory.CoreOptions,
    },
    {
        id: ExperiencePropertyType.FivePlusMultifamily,
        name: 'Multifamily (5+ unit structure)',
        category: ExperiencePropertyTypeCategory.Other,
    },
    {
        id: ExperiencePropertyType.ResidentialMixedUse,
        name: 'Residential Mixed Use',
        category: ExperiencePropertyTypeCategory.Other,
    },
    {
        id: ExperiencePropertyType.Commercial,
        name: 'Commercial',
        category: ExperiencePropertyTypeCategory.Other,
    },
];
